var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CurrencyInput',_vm._b({staticClass:"sw form-control",attrs:{"locale":"NL-nl","currency":_vm.currency,"value":_vm.selected},on:{"input":$value => _vm.$emit('input', $value)}},'CurrencyInput',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }